module.exports = __webpack_public_path__ + "static/img/star.10187bb4.png";